// Whole-minute label for a single video's runtime (given in seconds).
//
// We FLOOR (not round) with a 1-minute floor so the label never overstates
// the length: a 90s clip reads "1 min", not "2 min" (Math.round(1.5) === 2,
// which read as wrong next to the player's exact "1:30" timer). One minute is
// the smallest we show — sub-minute clips still say "1 min" rather than "0".
//
// Shared by web AND the native screens. It used to live only under src/web/,
// so the mobile screens each hand-rolled their own arithmetic and disagreed:
// GuestHome floored while ParentPreviewPlayer rounded, so the same 103-second
// video was listed as "1 min" and then opened as "2 min". One rule, one place.
export function videoMinutes(seconds: number | null | undefined): number {
  return Math.max(1, Math.floor((seconds ?? 0) / 60));
}
